<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-0">MAKLUMAT PEMBERIAN KENAIKAN GAJI DI BAWAH SSM</h3>
            <br />
            <div class="pl-lg-2">
                <b-row>
                    <b-col sm="1"></b-col>
                </b-row>
                <validation-provider name="Amaun Dalam Buku Servis" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col sm="3"> Amaun Dalam Buku Servis </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="2">
                            <b-form-input id="AmaunTelahTerima" v-model="Obj.AmaunTelahTerima" ></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col sm="3"> Catatan </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="8">
                            <!-- <b-form-input v-model="Obj.Catatan" :state="getValidation(validationContext)" class="custom-input"></b-form-input> -->
                            <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Tarikh Kuatkuasa </b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='3'>
                            <b-form-input v-model="Obj.EftDate" :state="getValidation(validationContext)" readonly></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-col>&nbsp;</b-col>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun","elemenId"],
    data() {
        return {
            Obj: {
                EftDate: "01-07-2007",
                Catatan:  `Pemberian Kenaikan Gaji di bawah SSM.
Kenaikan gaji sebanyak <PERATUS>% di bawah PP Bil. 7/2007.`,
            },
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            tpgList: [],
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },

        SimpanMaklumat() {
            this.Obj.coid=Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            this.Obj.elemenId=this.elemenId;
            console.log("log", this.Obj);

            GetsalaryService.setElemen7(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

                console.log("StatusSimpan", this.StatusSimpan);

                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }
            });
        }
    },
    computed: {
        coid() {
            return Store.state.MaklumatPeribadi[0].coid;
        }
    },
    created() {

        // GetselenggaraService.getSenaraiServClass()
        //     .then((resp) => {
        //         this.ServClassList = resp.data;
        //         //console.log(this.objekList);
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });

        // GetselenggaraService.getTPG()
        //     .then((resp) => {
        //         this.tpgList = resp.data;
        //         console.log("tpgList", this.tpgList);
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });
    }
}
</script>
